import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { db } from '../firebase';
import { collection, addDoc, Timestamp } from 'firebase/firestore';

const Areyouanartistslide = () => {
  const PCimage = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/CustomiseProjectSlideImages/custompc.jpg";
  const MOBILEimage = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/CustomiseProjectSlideImages/custommobile.jpg";
  const [name, setName] = useState('');
  const [contact, setContact] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState('');
  const [background, setBackground] = useState(PCimage);

  // The WhatsApp number where inquiries will be sent
  const WHATSAPP_NUMBER = '919016663115'; // Without the leading '+' for the URL

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setBackground(width < 365 ? MOBILEimage : PCimage);
    };

    handleResize(); // set initial background
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // 1. Store data in Firebase
      await addDoc(collection(db, 'custom_projects'), {
        name,
        contact,
        message,
        createdAt: Timestamp.now()
      });
      setSuccessMsg("Inquiry submitted successfully!");

      // 2. Prepare and open WhatsApp message
      const whatsappMessage = `Hello, I'm ${name}. My contact number is ${contact}. I'm interested in showcasing/selling artwork. Here's my vision: ${message}`;
      const encodedMessage = encodeURIComponent(whatsappMessage);
      const whatsappURL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodedMessage}`;

      // Open WhatsApp in a new tab/window
      window.open(whatsappURL, '_blank');

      // Clear form fields after successful submission and WhatsApp redirection
      setName('');
      setContact('');
      setMessage('');

    } catch (error) {
      console.error("Error storing data or opening WhatsApp: ", error);
      setSuccessMsg("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="py-24 px-6 relative bg-cover bg-center font-serif"
      style={{
        backgroundImage: `url(${background})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >

      <div className="absolute inset-0"></div>

      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-16 items-center relative">
        <motion.div
          className="space-y-6 text-center md:text-left"
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, ease: 'easeOut' }}
          viewport={{ once: true }}
        >
          <h2 className="text-5xl md:text-6xl text-white">
           ARE YOU AN ARTIST?
          </h2>
          <h2 className="text-gray-200 text-2xl md:text-3xl mt-7 leading-relaxed ">
            Want to showcase and sell your artwork with us?
          </h2>
          <h2 className="text-gray-200 text-lg md:text-xl mt-7 leading-relaxed ">
            Contact us for more details
          </h2>
        </motion.div>

        <motion.form
          onSubmit={handleSubmit}
          className="space-y-6 bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20 shadow-2xl"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2, ease: 'easeOut' }}
          viewport={{ once: true }}
        >
          <div>
            <label htmlFor="name" className="block text-sm font-serif font-semibold text-gray-200 mb-2">Full Name</label>
            <input
              id="name"
              type="text"
              placeholder="e.g., John Doe"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              className="w-full px-5 py-4 bg-black/20 text-white border border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 placeholder-gray-400"
            />
          </div>
          <div>
            <label htmlFor="contact" className="block text-sm font-serif font-semibold text-gray-200 mb-2">Contact Number</label>
            <input
              id="contact"
              type="tel"
              placeholder="e.g., +1 234 567 890"
              value={contact}
              onChange={(e) => setContact(e.target.value)}
              required
              className="w-full px-5 py-4 bg-black/20 text-white border border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 placeholder-gray-400"
            />
          </div>
          <div>
            <label htmlFor="message" className="block text-sm font-serif font-semibold text-gray-200 mb-2">Your Vision</label>
            <textarea
              id="message"
              rows="4"
              placeholder="Tell us about your project or inquiry..."
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              required
              className="w-full px-5 py-4 bg-black/20 text-white border border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 placeholder-gray-400"
            ></textarea>
          </div>

          {successMsg && (
            <p className="text-green-300 text-sm font-serif">{successMsg}</p>
          )}

          <motion.button
            type="submit"
            className="w-full bg-amber-600 hover:bg-amber-700 text-white font-semibold py-4 rounded-lg transition-all duration-300 shadow-lg"
            whileHover={{ scale: 1.02, boxShadow: '0 0 20px rgba(245, 158, 11, 0.6)' }}
            whileTap={{ scale: 0.98 }}
            disabled={loading}
          >
            {loading ? "Sending..." : "Submit Inquiry"}
          </motion.button>
        </motion.form>
      </div>
    </div>
  );
};

export default Areyouanartistslide;